import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { animateScroll } from 'react-scroll';
import classNames from 'classnames';
import _ from 'lodash';

import { setChannelNavPosition as setChannelNavPositionAction } from '../../actions/nav';

import "./styles.scss";

const contextTypes = {
  router: PropTypes.object
};

class ChannelList extends Component {

  state = {
    activeChannel: null,
    isOpen: false,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeChannelId !== nextProps.activeChannelId) {
      this.setState({ activeChannel: nextProps.activeChannelId });
    }
  }

  componentWillMount() {
    const { setChannelNavPosition } = this.props;
    let activeChannelId = (!Object.keys(this.context.router.params).length) ? 0 : this.props.activeChannelId;
    setChannelNavPosition(activeChannelId);
    this.setState({ activeChannel: this.props.activeChannelId });
  }

  onDocumentaryFilms = (e) => {
    e.preventDefault();
    this.context.router.push(`/films`);
  }

  _onClick = (e) => {
    const { channelId } = e.target.dataset;
    const { setChannelNavPosition } = this.props;
    setChannelNavPosition(channelId);
    this.setState({ isOpen: false });
    /**
     * jQuery handling for popping the MobileCamGroupCarousel out when you are scrolled down from
     * the start of the page. This could probably be cleaned up at some point.
     */
    var $navGroup = $('.nav-group');
    if (!$navGroup.hasClass('is-locked') && $(window).scrollTop() > $navGroup.height()) {
      $navGroup.addClass('is-locked').css('top', ($('.nav-wrapper').outerHeight() + $('.nav-category').outerHeight()) + 'px');
      $('body').css('margin-top', $navGroup.outerHeight());
      document.body.addEventListener('click', this.handleBodyClick);
    } else if (!$navGroup.hasClass('is-locked') && $(window).scrollTop() < $navGroup.height()) {
      animateScroll.scrollToTop();
    }

    this.setState({ activeChannel: channelId });
    e.preventDefault();
  }

  render() {
    const { activeChannel, isOpen } = this.state;
    const { channels } = this.props;
    const caretDirection = isOpen ? 'fa-angle-up' : 'fa-angle-down';
    return (
      <div className={classNames('full-channel-list','nav-category', { open: isOpen })}>
        <span className="toggle-icon" onClick={() => this.setState({ isOpen: !isOpen })} >
          <i className={`fa ${caretDirection}`} />
        </span>
        {
          channels.map( channel => {
            let active = parseInt(activeChannel, 10) === channel.id ? 'active' : '';
            return (
              <div
                className={`list-item ${active}`}
                key={channel.id}
              >
                <a href="#"
                  onClick={this._onClick}
                  data-channel-id={channel.id}
                  className={activeChannel}
                >
                  {channel.title}
                </a>
              </div>
            )
          })
        }
        <div className="list-item" key="99">
          <a href="#"
            onClick={(e)=>{this.onDocumentaryFilms(e)}}
            data-channel-id={999}
          >
            Films
          </a>
        </div>
      </div>
    )
  }
}

ChannelList.contextTypes = contextTypes;

const mapStateToProps = (state) => {
  const activeChannelId = _.get(state, 'nav.channelId', null) || _.get(state, 'nav.activeChannelId', null);
  return {
    channels: state.channels.data || [],
    activeChannelId,
  };
};

export default connect(mapStateToProps, { setChannelNavPosition: setChannelNavPositionAction })(ChannelList);
